"use strict";

import angular from "angular";

import DiasConfirm from "dias/core/confirm";
import DiasNotification from "dias/core/notification";

import services from "dias/workflow/services";
import functionCls from "./function";

const modul = angular.module("standard_workflowmodule.confirm", [
  DiasConfirm.name,
  DiasNotification.name,
  services.name
])

  .config(/*@ngInject*/WorkflowfunktionRegistryProvider => {
    WorkflowfunktionRegistryProvider.register("confirm", functionCls);
  });


export default modul;
